import { createSelector } from "reselect";
import { RootState } from "../store";
import { KitchenState } from "./kitchen.reducer";
import { Dishes } from "./kitchen.types";
import { dishArchived } from "../../constants";
import { getCategoryNameFromId } from "../../utils/utils.common";
import {
  isDishFeaturedPromo,
  isDishVisibleWithPromo,
} from "../../utils/promoCheck";
import { getKitchenTimezone } from "../../utils/timezone";

const selectKitchenReducer = (state: RootState): KitchenState => state.kitchen;

export const selectKitchen = createSelector(
  [selectKitchenReducer],
  (kitchenSlice) => kitchenSlice.kitchen
);

export const selectKitchenName = createSelector(
  [selectKitchenReducer],
  (kitchenSlice) => kitchenSlice.kitchen.kitchenName
);

const groupBy = (list: any, keyGetter: any) => {
  const map = new Map();
  list.forEach((item: any, i: number) => {
    const key = keyGetter(item);
    const collection = map.get(key);
    // console.log("COLLECTION: ")
    // console.log(key + " " +item.subcategory)
    if (!collection) {
      // map.set(item.subcategory + " " + key, [item]);
      map.set(key, [item]);
    } else {
      collection.push(item);
    }
  });
  return map;
};

const collectOnlineDishes = (kitchen: ReturnType<typeof selectKitchen>) => {
  const allDishes = [] as Dishes[];

  if (!kitchen?.dishes || Object.keys(kitchen).length === 0) {
    return allDishes;
  }

  const timezone = getKitchenTimezone(kitchen?.timezone);

  Object.entries(kitchen.dishes).forEach(([key, dish]) => {
    if (
      dish.dishStatus !== dishArchived &&
      dish.isDishAvailableOnline &&
      isDishVisibleWithPromo(dish, timezone)
    ) {
      dish["id"] = key;
      allDishes.push(dish);
    }
  });

  return allDishes;
};

export const FEATURED_PROMO_SECTION_ID = "Promotions";

export const selectFeaturedPromoDishes = createSelector(
  selectKitchen,
  (kitchen) => {
    const timezone = getKitchenTimezone(kitchen?.timezone);
    return collectOnlineDishes(kitchen).filter((dish) =>
      isDishFeaturedPromo(dish, timezone)
    );
  }
);

export const selectDishesMap = createSelector(selectKitchen, (kitchen) => {
  const timezone = getKitchenTimezone(kitchen?.timezone);
  const categoryDishes = collectOnlineDishes(kitchen).filter(
    (dish) => !isDishFeaturedPromo(dish, timezone)
  );

  const categoriesMap = groupBy(categoryDishes, (dish: Dishes) => {
    if (dish.categoryId) {
      return getCategoryNameFromId(kitchen?.dishCategories, dish.categoryId);
    }
    return dish.category;
  });

  return new Map([...categoriesMap.entries()]);
});

export const selectKitchenIsLoading = createSelector(
  [selectKitchenReducer],
  (kitchenSlice) => kitchenSlice.isLoading
);

export const selectKitchenError = createSelector(
  [selectKitchenReducer],
  (kitchenSlice) => kitchenSlice.error
);

export const selectOnlineOrdersConfigs = createSelector(
  [selectKitchenReducer],
  (kitchenSlice) => kitchenSlice.onlineOrdersConfigs
);
